import { Fragment, useEffect, useState } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { classNames } from '@progress/kendo-react-common'
import SearchBox from 'components/SearchBox'
import Translation from 'components/Translation'
import { useAuth } from 'context/AuthContext'
import Cookies from 'js-cookie'
import { useTenantContext } from 'context/TenantContext'
import { Tenant } from 'types/tenant'
import { ChevronDownIcon } from '@heroicons/react/solid'

export function TenantSelector() {
    const { tenant_switch_list, setUser } = useAuth()
    const { tenant, setTenant } = useTenantContext()
    const [is_opened, openMenu] = useState(false)
    const [filter, setFilter] = useState('')
    const [filtered_tenant_list, setFilteredTenantList] = useState([])

    useEffect(() => {
        if (filter?.length > 1) {
            let regex = new RegExp(filter, 'i')
            setFilteredTenantList(tenant_switch_list?.content?.filter((tenant: Tenant) => regex.test(tenant?.name) || regex.test(tenant?.user?.email || "") ))
        } else {
            setFilteredTenantList(tenant_switch_list?.content)
        }
    }, [filter, tenant_switch_list])

    function handleOnClick(tenant: Tenant) {
        const user = tenant.user
        if (user) {
            setUser({
                first_name: user?.firstName,
                last_name: user?.lastName,
                cognito_id: user?.cognitoId,
                uuid: user?.id,
                id: user?.id,
                email: user?.email,
                city: user?.city,
                country: user?.country,
                date_of_birth: user?.dateOfBirth,
                gender: user?.gender,
                phone: user?.phone,
                state: user?.state,
                street_1: user?.street1,
                street_2: user?.street2,
                zip: user?.zip
            })
            setTenant(tenant)
            Cookies.remove('tenant_id')
            Cookies.remove('email')
            Cookies.set('tenant_id', tenant?.id, {
                sameSite: 'None',
                secure: true,
            })
            Cookies.set('email', user?.email, {
                path: '/',
                sameSite: 'None',
                secure: true,
            })
        }

        openMenu(false)
    }

    return (
        <Menu
            as="div"
            className={classNames(
                'relative inline-block text-left'
            )}
        >
            <div>
                <Menu.Button
                    className={classNames(
                        'inline-flex justify-center items-center w-full',
                        'rounded-md border border-gray-150 shadow-sm px-2 py-1.5 bg-white',
                        'text-sm font-medium text-gray-700',
                        'hover:bg-gray-50'
                    )}
                    // onClickCapture={() => {
                    //     openMenu(!is_opened)
                    // }}
                >
                    <i
                        className="feather-filter text-sm mr-2"
                        aria-hidden="true"
                    />
                    <span>
                        {
                            tenant?.name ||
                        <Translation
                            content_key='switch_tenant'
                        />
                        }
                    </span>
                    <ChevronDownIcon
                            className="w-5 h-5 ml-1 mr-1"
                            aria-hidden="true"
                        />
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
                // show={is_opened}
            >
                <Menu.Items
                    static
                    className={classNames(
                        'absolute mt-2 w-80 px-3',
                        'rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5',
                        'focus:outline-none'
                    )}
                >
                    <div
                        className="py-4 px-2"
                        
                    >
                            <Menu.Item>
                                <SearchBox
                                    value={filter}
                                    setValue={setFilter}
                                    key="tenant_selector"
                                />
                            </Menu.Item>
                        <div className="overflow-y-auto overflow-x-hidden mt-3 max-h-[40vh]">
                            {filtered_tenant_list &&
                                filtered_tenant_list.map((t: any, index: number) => {
                                    return (
                                        <Menu.Item key={index}>
                                            {({ active }) => (
                                                <div
                                                    className={classNames(
                                                        active
                                                            ? 'bg-gray-100 text-gray-900'
                                                            : 'text-gray-700',
                                                        'block text-sm'
                                                    )}
                                                    onClick={() => { handleOnClick(t) }}
                                                >
                                                    <label
                                                        htmlFor={`tenant-${index}`}
                                                        className="flex min-w-0 flex-1 text-gray-500 h-full px-1 py-2 cursor-pointer"
                                                    >
                                                        <span>
                                                            {
                                                                t?.name + " : " + t?.user?.email
                                                            }
                                                        </span>
                                                    </label>
                                                </div>
                                            )}
                                        </Menu.Item>
                                    )
                                })
                            }
                        </div>
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    )
}

export default TenantSelector
